__turbopack_context__.v({
  "for-sale-title": "homepage-zoocasa-light-module-scss-module__GtK8tq__for-sale-title",
  "homepage-btn": "homepage-zoocasa-light-module-scss-module__GtK8tq__homepage-btn",
  "section-blog": "homepage-zoocasa-light-module-scss-module__GtK8tq__section-blog",
  "section-content-block": "homepage-zoocasa-light-module-scss-module__GtK8tq__section-content-block",
  "section-featured": "homepage-zoocasa-light-module-scss-module__GtK8tq__section-featured",
  "section-for-sale": "homepage-zoocasa-light-module-scss-module__GtK8tq__section-for-sale",
  "section-keywords": "homepage-zoocasa-light-module-scss-module__GtK8tq__section-keywords",
  "section-sold": "homepage-zoocasa-light-module-scss-module__GtK8tq__section-sold",
  "zoocasa-light": "homepage-zoocasa-light-module-scss-module__GtK8tq__zoocasa-light",
});
